import { Company } from "../model/company";

export interface LoginData {
    username: string
    password: string
}

export interface UserSession {
    token: string
    user: User
    expiresAt: Date
}

export interface User {
    id: string
    username: string
    email: string
    phoneNumber: string
    lang: string
    role: string
}

export enum Roles {
    SuperAdmin = 'super_admin',
    CompanyAdmin = 'company_admin',
    CompanyManager = 'company_manager',
	Serviceman   = "serviceman",
    User = 'user',
    Operator = 'operator',
    Coordinator = 'coordinator'
}

export const ManagerRoles = [Roles.CompanyAdmin, Roles.CompanyManager, Roles.SuperAdmin]

export class UsersRepository {

    constructor() { }

    async list(): Promise<Company[]> {
        return fetch('/api/schema/companies').then((response) => {
            return response.json()
        });
    }

    async login(data: LoginData): Promise<UserSession> {
        return fetch(`/api/schema/users/login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((response) => {
            return response.json()
        });
    }

    async loginByCard(ucid: string): Promise<UserSession> {
        return fetch(`/api/schema/users/login/bycard`, {
            method: 'POST',
            body: JSON.stringify({
                ucid: ucid
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((response) => {
            return response.json()
        });
    }

    roles(): string[] {
        return [Roles.User, Roles.SuperAdmin, Roles.Serviceman, Roles.CompanyManager, Roles.Operator, Roles.Coordinator] //'company_admin',
    }
}